export interface PageDTO<T> {
  content: Array<T>;
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  number_of_elements: number;
  total_elements: number;
  total_pages: number;
}

export interface CursorDTO<T> {
  content: Array<T>;
  cursor: string | null;
  size: number;
}

export interface RBACOperation {
  resource: string;
  action: string;
}

export interface RBACVerification {
  account_id: string;
  allowed_operations: RBACOperation[];
  denied_operations: RBACOperation[];
}

export const getInitials = (name: string): string => {
  if (typeof name === 'string') {
    const splittedName = name.trim().split(/\s+/);
    if (splittedName.length === 2) {
      const firstLetter = splittedName[0].charAt(0).toUpperCase();
      const secondLetter = splittedName[1].charAt(0).toUpperCase();
      return `${firstLetter}${secondLetter}`;
    }
    return name.slice(0, 2).toUpperCase();
  }
  return '';
};
